import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials so httpOnly auth cookies are sent. Bearer token from
// localStorage is still attached as a fallback for any flow that hasn't
// migrated yet (e.g., older test harnesses).
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
 const token = localStorage.getItem("gls_token");
 if (token) config.headers.Authorization = `Bearer ${token}`;
 return config;
});

export function formatApiError(detail) {
 if (detail == null) return "Something went wrong. Please try again.";
 if (typeof detail === "string") return detail;
 if (Array.isArray(detail))
 return detail
 .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
 .filter(Boolean)
 .join(" ");
 if (detail && typeof detail.msg === "string") return detail.msg;
 return String(detail);
}
